export const TEAM_LEAD_ID = "6666f181596b5652fb1d9242"
export const ACCOUNT_AND_FINANCE_ID = "6666f1ab596b5652fb1d9243"
export const TEAM_MEMBER_ID = "6666f089596b5652fb1d9241"